import { MESSAGE_TYPES } from "features/results/constants/messageTypeGroups";
import { usePatientResults } from "features/results/hooks/usePatientResults";

const MESSAGE_TYPES_REQUESTED = [MESSAGE_TYPES.dischargeSummary];

/*
 * Discharge summaries for one patient, for the Documents screen's own section (KIN-2028).
 *
 * They arrive through the same common results endpoint that feeds the Results screen, where they
 * sit inside the broad "COOP / Discharges" filter alongside out-of-hours co-op notes, outpatient
 * clinic letters and ED letters. Here the one message type is requested instead of the group, so
 * the section holds discharge summaries and nothing else. No backend change: the endpoint already
 * accepts an individual message type next to the group tokens.
 *
 * `includeXsl` is already on in `usePatientResults`, so each row carries the XML and its
 * stylesheet and the document can be rendered without a second fetch.
 */
export const usePatientDischargeSummaries = ({
  patientId,
  page,
  rows,
  enabled = true,
}) => {
  const { data, isLoading, isError, refetch } = usePatientResults({
    patientId,
    messageTypes: MESSAGE_TYPES_REQUESTED,
    orderBy: "DESC",
    limit: rows,
    offset: (page - 1) * rows,
    enabled,
  });

  return {
    summaries: data?.results ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isError,
    refetch,
  };
};
